import React, { useState } from "react";
import { Modal } from "antd";
import Input from "../components/shared/input";
import Button from "../components/shared/button";

const AddNewModal = ({ planModelOpen, setplanModelOpen }) => {
  const [showSecondSection, setShowSecondSection] = useState(false); // Toggle between sections
  const [benefits, setBenefits] = useState([""]); // State to manage dynamic Benefit inputs

  const handleOk = () => {
    setplanModelOpen(false);
  };

  const handleCancel = () => {
    setplanModelOpen(false);
  };

  const handleNextClick = () => {
    setShowSecondSection(true); // Show the second section when "Next" is clicked
  };

  const handleAddBenefit = () => {
    setBenefits([...benefits, ""]); // Add a new blank benefit input
  };

  const handleDeleteBenefit = (index) => {
    setBenefits(benefits.filter((_, i) => i !== index)); // Remove benefit input at the specified index
  };

  const handleBenefitChange = (index, value) => {
    const updatedBenefits = [...benefits];
    updatedBenefits[index] = value; // Update the benefit value at the specified index
    setBenefits(updatedBenefits);
  };

  return (
    <>
      <Modal
        open={planModelOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        className="del-modal"
        centered={true}
        width="35%"
      >
        <div className="modal-content py-[20px]  ">
          <h5 className="text-blue font-manrope px-[26px] font-medium max-w-[327px] mb-[47px]">
            Add new plan
          </h5>

          {/* First Section - Visible Initially */}
          {!showSecondSection && (
            <div className="flex flex-col items-start gap-[47px] px-[26px]">
              <div className="w-full flex flex-col gap-[16px]">
                <Input
                  label="Title"
                  type="text"
                  name="text"
                  placeholder="1"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                />
                <Input
                  label="About plan"
                  type="text"
                  name="text"
                  placeholder="Write about plan"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                />
                <Input
                  label="Duration (days)"
                  type="number"
                  name="text"
                  placeholder="0"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                />
                <Input
                  label="Price"
                  type="number"
                  name="text"
                  placeholder="0"
                  className="dash-input-field"
                  wrapperClass="dash-wrapper"
                  labelClass="dash-label"
                  prefix="$"
                  leftImg="../../assets/icons/dollar.svg"
                />
              </div>
              <Button
                text="Next"
                className="button btn-blue !rounded-[39px] large mt-[45px] m-auto"
                height={45}
                width={176}
                onClick={handleNextClick} // Show second section on click
              />
            </div>
          )}

          {/* Second Section - Visible After "Next" Button Click */}
          {showSecondSection && (
            <div className="flex flex-col items-start gap-[6px] pl-[22px] pr-[10px]">
              <p className="text-blue font-medium medium">Benefits</p>
              <div className="flex flex-col gap-[20px] w-full max-h-[40vh] pr-[16px] overflow-y-auto">
                {benefits.map((benefit, index) => (
                  <div
                    key={index}
                    className="w-full flex items-center gap-[10px] "
                  >
                    <Input
                      type="text"
                      name="text"
                      placeholder="I"
                      className="dash-input-field"
                      wrapperClass="dash-wrapper"
                      labelClass="dash-label"
                      value={benefit}
                      onChange={(e) =>
                        handleBenefitChange(index, e.target.value)
                      }
                    />
                    <img
                      src="../../assets/icons/del.png"
                      alt="Delete"
                      className="cursor-pointer w-[34px] h-[34px] "
                      onClick={() => handleDeleteBenefit(index)}
                    />
                  </div>
                ))}
                <Button
                  text="Add"
                  className="button btn-blue-border !rounded-[4px] large m-auto col-res"
                  height={40}
                  width="100%"
                  imgright="gg:add"
                  onClick={handleAddBenefit}
                />
              </div>
              <Button
                text="Add now"
                className="button btn-blue !rounded-[39px] large mt-[45px] m-auto"
                height={45}
                width={176}
                onClick={handleOk}
              />
            </div>
          )}
        </div>
      </Modal>
    </>
  );
};

export default AddNewModal;
